import OnvoBase, { JobUpdateEvent } from "../base.js";
import { Message } from "../types/index.js";
export class OnvoQuestion extends OnvoBase {
  #id: string;

  constructor(id: string, apiKey: string, options?: { endpoint: string }) {
    super(apiKey, options);
    this.#id = id;
  }
  /**
   * Retrieves the messages for the question.
   *
   * @return {Promise<Message[]>} A promise that resolves to an array of messages.
   */
  getMessages(): Promise<Message[]> {
    return this._fetchBase(
      `/api/questions/${this.#id}/messages`
    ) as Promise<Message[]>;
  }

  /**
   * Updates the messages for the question.
   *
   * @param {string} content - The text content to update.
   * @return {Promise<Message & { _meta: {status: string, url: string} }>} A promise that resolves to the updated message.
   */
  completion(content: string, onEvent?: (event: JobUpdateEvent) => void): Promise<Message & { _meta: { status: string, url: string } }> {
    return this._fetchStreamBase(
      `/api/questions/${this.#id}/messages`,
      "POST",
      { content },
      onEvent
    ) as Promise<Message & { _meta: { status: string, url: string } }>;
  }

  /**
   * Updates a message for the question.
   *
   * @param {string} messageId - The id of the message to update.
   * @param {string} content - The content of the message to update.
   * @return {Promise<Message & { _meta: {status: string, url: string} }>} A promise that resolves to the updated message.
   */
  updateMessage(messageId: string, content: string, onEvent?: (event: JobUpdateEvent) => void): Promise<Message & { _meta: { status: string, url: string } }> {
    return this._fetchStreamBase(
      `/api/questions/${this.#id}/messages/${messageId}`,
      "PUT",
      { content },
      onEvent
    ) as Promise<Message & { _meta: { status: string, url: string } }>;
  }

  /**
   * Votes on a message.
   *
   * @param {string} messageId - The id of the message to vote on.
   * @param {('up' | 'down')} vote - The vote to cast.
   * @param {string} [reason] - The reason for the vote.
   * @returns {Promise<Message>} A promise that resolves to the updated message.
   */
  voteMessage(messageId: string, vote: 'up' | 'down', reason?: string): Promise<Message> {
    return this._fetchBase(
      `/api/questions/${this.#id}/messages/${messageId}`,
      "POST",
      { vote, vote_reason: reason }
    ) as Promise<Message>;
  }
}

